module.exports = __webpack_public_path__ + "static/media/redantpdx.3707fb54.png";